export default "__VITE_ASSET__8_f0JzT0__"